import { logs } from '@glovo/opentelemetry'
import { initCustomMetrics } from './custom-metrics/index.node'

// eslint-disable-next-line no-restricted-imports
export { withScope, type Logger } from '@glovo/logger'
// eslint-disable-next-line no-restricted-imports
export { metrics, type CustomMetricType } from '@glovo/custom-metrics'

export { logger } from './logger/index.node'
export { decorateConsole } from './logger/decorate-console'

let isInitialized = false

export const initObservability = async () => {
  if (isInitialized) {
    return
  }
  initCustomMetrics()
  logs.init({ serviceName: 'customer-web-react' })
  isInitialized = true
}
